import { fromJS } from 'immutable';

import { INIT, INIT_SUCCESS, INIT_FAILED } from './types';

export const initialState = fromJS({
  loading: false,
  error: false,
});

export default (state = initialState, action: any) => {
  switch (action.type) {
    case INIT:
      return state.set('loading', true);

    case INIT_SUCCESS:
      return state.set('loading', false);

    case INIT_FAILED:
      return state.merge({ loading: false, error: action.error });

    default:
      return state;
  }
};
